import * as types from './types';

const INITIAL_STATE = {
  initializing: true,
  fiscalYear: null,
  unclosedDates: null,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.CLOSE_SCHOOL_YEAR_INITIALIZING:
      return { ...state, initializing: payload };
    case types.CLOSE_SCHOOL_YEAR_SET_FISCAL_YEAR:
      return {
        ...state,
        fiscalYear: payload,
      };
    case types.CLOSE_SCHOOL_YEAR_SET_UNCLOSED_DATES:
      return {
        ...state,
        unclosedDates: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/CloseSchoolYear/state/reducer.js